<script setup lang="ts">
import { AppLink } from '#components'
import { useDynamicIcons } from '~layers/shared/utils/useDynamicIcons.ts'

defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

function getElement(to: string | null | undefined) {
  return to ? AppLink : 'div'
}

const { loadIcon } = useDynamicIcons()
</script>

<template>
  <StrapiSlice
    class="ct-usp"
    :slice="slice"
    :index="index"
  >
    <h2
      v-if="slice?.Usps?.Title"
      class="ct-usp__heading"
    >
      {{ slice.Usps.Title }}
    </h2>

    <ul
      v-if="slice?.Usps?.Usp?.length"
      class="ct-usp__list"
    >
      <li
        v-for="(usp, index) in slice.Usps.Usp"
        :key="index"
        class="ct-usp__item"
      >
        <component
          :is="getElement(usp.Link)"
          :to="usp.Link"
          class="ct-usp__link"
        >
          <Icon :name="loadIcon(usp.Icon)" />
          <span class="ct-usp__label">{{ usp.Label }}</span>
          <span class="ct-usp__description">{{ usp.Description }}</span>
        </component>
      </li>
    </ul>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/Usp.css");
</style>
